import { createSaga } from './saga-helpers';

import * as Api from '../api/docs-api';

const watchGetDocs = createSaga({
    type: 'DOCS_FETCH',
    fn: Api.fetchDocs,
    args: action => [action.payload],
    successPayload: ({ items, hasMore } = {}, action) => ({
        docs: items,
        hasMore,
        ...action.payload
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        ...action.payload
    })
});

const watchCreateDoc = createSaga({
    type: 'DOC_CREATE',
    fn: Api.createDoc,
    args: action => [action.payload.doc],
    successPayload: (doc, action) => ({
        docId: doc.doc_id,
        fragment: action.payload.doc
    }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        fragment: action.payload.doc
    })
});

const watchGetDoc = createSaga({
    type: 'DOC_FETCH',
    fn: Api.fetchDoc,
    args: action => [action.payload.docId],
    successPayload: doc => ({ doc }),
    errorPayload: (e, action) => ({
        message: e.message || e,
        docId: action.payload.docId
    })
});

const watchUpdateDoc = createSaga({
    type: 'DOC_UPDATE',
    fn: Api.updateDoc,
    args: action => [action.payload.docId, action.payload.docProps],
    successPayload: doc => ({ doc })
});

const watchRemoveDoc = createSaga({
    type: 'DOC_REMOVE',
    fn: Api.removeDoc,
    args: action => [action.payload.docId]
});

const watchAddDocMembers = createSaga({
    type: 'DOC_ADD_MEMBERS',
    fn: Api.addDocMembers,
    args: action => [action.payload.docId, action.payload.members],
    successPayload: (doc, action) => ({
        doc,
        docId: action.payload.docId,
        members: action.payload.members
    })
});

const watchRemoveDocMembers = createSaga({
    type: 'DOC_REMOVE_MEMBERS',
    fn: Api.removeDocMembers,
    args: action => [action.payload.docId, action.payload.members],
    successPayload: doc => ({ doc })
});

const watchAddDocLabels = createSaga({
    type: 'DOC_LABELS_ADD',
    fn: Api.addDocLabels,
    args: action => [action.payload.docId, action.payload.labels]
});

const watchRemoveDocLabels = createSaga({
    type: 'DOC_LABELS_REMOVE',
    fn: Api.removeDocLabels,
    args: action => [action.payload.docId, action.payload.labels]
});

const watchGetDocShareLink = createSaga({
    type: 'GET_DOC_SHARE_LINK',
    fn: Api.getDocShareLink,
    args: action => [action.payload.docId],
    successPayload: doc => ({ doc })
});

const watchMoveDoc = createSaga({
    type: 'DOC_MOVE',
    fn: Api.moveDoc,
    args: action => [action.payload.docId, action.payload.moveProps],
    successPayload: doc => ({ doc })
});

const sagas = [watchGetDocs, watchCreateDoc, watchGetDoc, watchUpdateDoc, watchRemoveDoc, watchAddDocMembers, watchRemoveDocMembers, watchAddDocLabels, watchRemoveDocLabels, watchGetDocShareLink, watchMoveDoc];

export default sagas;
